import withRouter from "hoc/withRouter";
import {
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import trainsService from "services/admin/trainsService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const TrainList = () => {
  const orgID = localStorage.getItem("orgID") || "";
  const {
    data: trainsResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["trains", { orgID }],
    queryFn: async () => {
      const response: any = await trainsService.getAll();
      return response.data;
    },
  });

  const handleDelete = async (id: string) => {
    if (!window.confirm("Удалить поезд?")) return;
    await trainsService.delete(id);
    refetch();
  };

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress></CircularProgress>
        </div>
      );
    }
    const rows: any[] = (trainsResponse as any)?.data || [];
    if (rows.length === 0) {
      return (
        <div>Поезда отсутствуют. Чтобы добавить поезд, нажмите на кнопку "Добавить" сверху</div>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Номер</TableCell>
            <TableCell>Маршрут</TableCell>
            <TableCell>Тип</TableCell>
            <TableCell>Филиал</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((c: any, index: number) => (
            <TableRow key={c.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{c.number}</TableCell>
              <TableCell>{c.route}</TableCell>
              <TableCell>{c.type}</TableCell>
              <TableCell>{c.branch?.name}</TableCell>
              <TableCell>
                <div className="flex gap-2 items-center">
                  <Link to={`/admin/trains/edit/${c.id}`}>
                    <FaPencil />
                  </Link>
                  <IconButton color="error" onClick={() => handleDelete(c.id)}>
                    <FaTrashAlt />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <ListPage pageTitle="Список поездов" pathToAdd={`/admin/trains/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(TrainList);
